<template>
  <div>
    <div class="d-flex justify-end">
      <v-card-actions>
        <v-btn class="default-action-btn" @click="overlay = true"
          >Assign Documents</v-btn
        >
        <v-overlay :value="overlay" class="d-flex">
          <div class="d-flex justify-end">
            <v-btn icon @click="overlay = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <document-assign
            :userId="parseInt(userId)"
            @save="save"
          ></document-assign>
        </v-overlay>
      </v-card-actions>
    </div>

    <v-sheet class="document-list">
      <documents-tree
        :documents="documents"
        :allowDelete="false"
        :allowEdit="false"
      ></documents-tree>
    </v-sheet>
  </div>
</template>

<script>
import titleMixin from "@/mixins/titleMixin"
import eventMixin from "@/mixins/eventMixin"
import DocumentsTree from "@/components/DocumentsTree"
import User from "@/lib/user"
import DocumentAssign from "@/containers/documents/DocumentAssign"
import { mapGetters } from "vuex"

export default {
  mixins: [titleMixin, eventMixin],
  components: { DocumentsTree, DocumentAssign },
  data: function() {
    return {
      overlay: false,
      title: "Documents",
      userId: this.$route.params.id,
      userType: User.getUserType(),
      showDelete: !User.isMember()
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.id) {
      this.userId = to.params.id
      this.$store.dispatch("documents/loadDocuments", { userId: this.userId })
    }
    next()
  },
  computed: {
    ...mapGetters("documents", ["getSelected"]),
    documents() {
      return this.getSelected
    }
  },
  created() {
    this.$store.dispatch("documents/loadDocuments", { userId: this.userId })
  },
  methods: {
    setLink(el) {
      return el.url
    },
    save({ available, selected }) {
      this.overlay = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/buttons";
</style>
